/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../client/js/components/PageTitle'
import UserForm from './UserForm'
import { fetchUser } from '../lib/userAPIClient'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../client/js/components/Page'
import BreadcrumbCard from '../../../client/js/components/breadcrumb/BreadcrumbCard'
import AnchorLink from '../../../client/js/components/AnchorLink'
import AdminBreadcrumb from '../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { getUserListLink } from '../lib/userLinks'

function UserFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const userId = parseInt(params.id, 10)

  const userQuery = useQuery({
    enabled: true,
    queryKey: ['user', userId],
    queryFn: () => userId > 0
      ? fetchUser(userId)
      : Promise.resolve({} as Partial<User>),
    refetchOnWindowFocus: false
  })
  const { data: user } = userQuery

  const title = userId > 0 && user != null
    ? user.username
    : intl.formatMessage({
      id: 'create_user',
      defaultMessage: 'Créer un utilisateur'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getUserListLink()}>
              <FormattedMessage
                id="users"
                defaultMessage="Utilisateurs"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={userQuery}
            render={() => (
              <UserForm initialValues={user} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default UserFormPage
